// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import productDescriptionVariantStyles from "@conklin/App/SharedStyles/ProductDescriptionStyles";
import { productListLineStyles } from "@conklin/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { staticListProductListLineStyles } from "@conklin/Overrides/Widgets/StaticList/StaticListProductListLine";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

staticListProductListLineStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 120px;
            height: 120px;
            justify-content: center;
            ${xScreen("lte", "md")} {
                width: 99px;
                height: 99px;
            }
        `,
    },
    img: {
        css: css`
            width: auto;
            height: auto;
            max-height: 100%;
            max-width: 100%;
            object-fit: contain;
        `,
    },
};

staticListProductListLineStyles.productDescriptionStyles = {
    ...productDescriptionVariantStyles.small,
};

staticListProductListLineStyles.productPartNumbersStyles = {
    ...mergeWithCss(cartLineSharedStyles.productPartNumbers, {
        container: {
            css: css`
                margin-bottom: 8px;
            `,
        },
    }),
};

staticListProductListLineStyles.productAvailabilityStyles = productListLineStyles.productAvailabilityStyles;

staticListProductListLineStyles.productPriceStyles = {
    ...mergeWithCss(productListLineStyles.productPriceStyles, {
        priceLabelText: {
            css: css`
                display: none;
            `,
        },
    }),
};

staticListProductListLineStyles.productUnitOfMeasureSelectStyles = {
    mergeCss: true,
    labelProps: {
        css: css`
            @media print {
                font-size: 12px;
            }
        `,
    },
    iconProps: {
        size: 13,
        css: css`
            @media print {
                display: none;
            }
            &&&& {
                display: flex;
                justify-content: flex-end;
                padding-right: 13px;
                width: auto;
                height: 23px;
            }
            svg {
                width: 8px;
                height: 13px;
            }
        `,
    },
    css: css`
        &&&& {
            height: 26px;
        }
    `,
};

staticListProductListLineStyles.addToCartButton = {
    sizeVariant: "small",
    css: css`
        width: 100%;
        white-space: nowrap;
    `,
};

staticListProductListLineStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

staticListProductListLineStyles.productAddToCartButtonStyles = {
    sizeVariant: "small",
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};

staticListProductListLineStyles.quantityAddtoCartWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
        width: 100%;
        gap: 8px;
    `,
};

staticListProductListLineStyles.deleteItemWrapper = {
    css: css`
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        line-height: 14px;
    `,
};

staticListProductListLineStyles.quantityOrderedStyles = {
    qtyFieldStyles: {
        wrapper: {
            css: css`
                width: 70px;
                min-width: 70px;
            `,
        },
    },
};

staticListProductListLineStyles.productUnitOfMeasureSelectStyles = {
    labelProps: {
        css: css`
            display: none;
            @media print {
                display: block;
            }
        `,
    },
    sizeVariant: "small",
    cssOverrides: {
        inputSelect: css`
            margin: 0;
        `,
        formField: css`
            width: 111px;
            ${IconWrapper} {
                background: none;
            }
        `,
    },
};

staticListProductListLineStyles.listLineContainer = {
    container: {
        css: css`
            border-bottom: 1px solid ${color("common.border")};
        `,
    },
    deleteItem: {
        css: css`
            grid-column: 5 / 6;
            grid-row: 3 / 5;
            padding-top: 12px;
            ${xScreen("lte", "md")} {
                grid-column: 3 / 6;
                grid-row: 6 / 7;
            }
            ${xScreen("lte", "xs")} {
                grid-column: 2 / 6;
                z-index: 1;
            }
        `,
    },
};
